import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    const targetUrl = this.hasUrlValue ? this.urlValue : window.location.href
    window.location.href = targetUrl
  }
}
